export const faq = {
  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Trouvez rapidement des réponses à vos questions sur Suji",
  "faq.search_placeholder": "Rechercher dans la FAQ...",
  "faq.search_results": "Résultats de recherche",
  "faq.no_results": "Aucun résultat trouvé",
  "faq.try_keywords": "Essayez avec d'autres mots-clés",
  "faq.not_found_title": "Vous ne trouvez pas votre réponse ?",
  "faq.not_found_text": "Notre équipe support est là pour vous aider. Contactez-nous et nous vous répondrons rapidement.",
  "faq.contact_us": "Nous contacter",
  "faq.live_chat": "Chat en direct",
  
  // Categories
  "faq.cat_general": "Général",
  "faq.cat_buyers": "Pour les acheteurs",
  "faq.cat_suppliers": "Pour les fournisseurs",
  "faq.cat_technical": "Technique",
  
  // General Questions
  "faq.general.q1": "Qu'est-ce que Suji ?",
  "faq.general.a1": "Suji est un moteur de recherche géolocalisé qui vous permet de trouver facilement tous les fournisseurs au Nigeria. Notre plateforme connecte les entreprises avec les meilleurs fournisseurs locaux dans toutes les catégories.",
  "faq.general.q2": "Comment utiliser Suji ?",
  "faq.general.a2": "Entrez simplement ce que vous recherchez dans la barre de recherche, spécifiez votre localisation et choisissez une catégorie si nécessaire. Nos résultats sont triés par pertinence et proximité géographique.",
  "faq.general.q3": "Suji est-il gratuit ?",
  "faq.general.a3": "Oui, la recherche de fournisseurs sur Suji est entièrement gratuite. Les fournisseurs peuvent également créer un profil de base gratuitement.",
  
  // Buyer Questions
  "faq.buyers.q1": "Comment contacter un fournisseur ?",
  "faq.buyers.a1": "Sur la page de détail de chaque fournisseur, vous trouverez ses coordonnées : téléphone, email et un formulaire de contact direct. Vous pouvez également utiliser notre assistant IA pour planifier un rendez-vous.",
  "faq.buyers.q2": "Comment vérifier la fiabilité d'un fournisseur ?",
  "faq.buyers.a2": "Nous vérifions tous nos fournisseurs partenaires. Recherchez le badge \"Vérifié\" sur leur profil. Vous pouvez également consulter les avis et évaluations laissés par d'autres clients.",
  "faq.buyers.q3": "Puis-je filtrer les résultats par distance ?",
  "faq.buyers.a3": "Oui, vous pouvez définir un rayon de recherche (10, 25, 50 ou 100 km) pour trouver les fournisseurs les plus proches de votre localisation.",
  
  // Supplier Questions
  "faq.suppliers.q1": "Comment ajouter mon entreprise sur Suji ?",
  "faq.suppliers.a1": "Cliquez sur \"Ajouter votre entreprise\" dans le menu principal, puis créez votre compte et remplissez les informations de votre entreprise. La création d'un profil de base est gratuite.",
  "faq.suppliers.q2": "Comment obtenir le badge \"Vérifié\" ?",
  "faq.suppliers.a2": "Après avoir créé votre profil, notre équipe vérifiera les informations de votre entreprise. Ce processus prend généralement 2-3 jours ouvrables. Vous recevrez une notification une fois la vérification terminée.",
  "faq.suppliers.q3": "Puis-je modifier mes informations après inscription ?",
  "faq.suppliers.a3": "Oui, vous pouvez modifier toutes vos informations depuis votre tableau de bord fournisseur. Les modifications majeures peuvent nécessiter une nouvelle vérification.",
  "faq.suppliers.q4": "Comment améliorer la visibilité de mon entreprise ?",
  "faq.suppliers.a4": "Complétez entièrement votre profil, ajoutez des photos de qualité, encouragez vos clients à laisser des avis et gardez vos informations à jour. Nous proposons également des options premium pour plus de visibilité.",
  
  // Technical Questions
  "faq.technical.q1": "Sur quels appareils puis-je utiliser Suji ?",
  "faq.technical.a1": "Suji fonctionne sur tous les appareils : ordinateurs, tablettes et smartphones. Notre site web est optimisé pour tous les navigateurs modernes.",
  "faq.technical.q2": "Mes données personnelles sont-elles sécurisées ?",
  "faq.technical.a2": "Oui, nous prenons la sécurité très au sérieux. Toutes vos données sont cryptées et nous respectons strictement les réglementations sur la protection des données.",
  "faq.technical.q3": "Que faire si je rencontre un problème technique ?",
  "faq.technical.a3": "Contactez notre support technique via la page Contact ou utilisez notre assistant IA. Nous répondons généralement dans les 24 heures."
};

export default faq;
